import { Component, ViewChild, OnInit, AfterContentChecked, OnDestroy } from '@angular/core';
import { Subject, EMPTY, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

import { PaginationComponent } from '../shared/components/pagination/pagination.component';
import { MatDialog, MatDialogRef } from "@angular/material";

import { SnackbarService } from "../shared/services/snackbar.service";
import { PatientPaymentService } from "./patient-payment-details.service";
import { TooltipService } from "../shared/services/tooltip.service";
import { RestrictOutsideScrollService } from "../shared/services/restrict-outside-scroll.service";
import { PaymentDetailsPopupComponent } from "../shared/components/payments-details-popup/patient-payment-details-popup.component"

import { config } from "../../../config/index";

@Component({
    template: require('./patient-payment-details.component.html'),
    styles: [require('./patient-payment-details.component.less')],
    providers: [PatientPaymentService, SnackbarService, TooltipService],
    preserveWhitespaces: true
})

export class PatientPaymentDetailsComponent implements OnInit, AfterContentChecked, OnDestroy {

    paginationItems: any;
    reqPageOffset: number = 0;
    reqItemsPerPage: number = 10;
    startCount: any;
    endCount: any;
    searchValue: string = '';
    master: any;
    selectedType: any;
    paymentTotaslCount: any;
    patientPaymentDetails: any = [];
    selectedLocation: any;
    selectedPaymentType: any;
    locationList: any = [];
    loading: boolean = true;
    currency: any;
    loadingPopup: boolean = false;
    sortParams: any = ['name', 'tx_started_on'];
    sortParamsConfig: any = [];
    sortParam: string;
    order: string;
    isTouchDevice: boolean;

    limitInputSub$: Subject<string> = new Subject<string>();
    searchInputSub$: Subject<string> = new Subject<string>();
    additionalInputSub$: Subject<string> = new Subject<string>();
    inputSubscription: Subscription;
    oneTimeApiSubscription: Subscription;
    limitSubscription: Subscription;
    searchSubscription: Subscription;
    apiSubscriptions: Subscription[] = [];
    recentPaymentsApiSubscription: Subscription;

    dialogRefPaymentPopup: MatDialogRef<PaymentDetailsPopupComponent>;

    @ViewChild("paginationId", { static: false }) setPagination: PaginationComponent;
    @ViewChild("oneTimePaymentDialog", { static: false }) oneTimePaymentDialog: any;
    @ViewChild("oneTimeConfirmationDialog", { static: false }) oneTimeConfirmationDialog: any;

    constructor(
        public _patientPaymentService: PatientPaymentService,
        public _mdlSnackbarService: SnackbarService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        private _tooltipService: TooltipService,
        public dialog: MatDialog
    ) {
    }

    // for sorting
    sort(param: any) {
        this.sortParam = param;
        if (this.sortParamsConfig[param].firstToggle) {
            this.sortParamsConfig[param].firstToggle = false;
        } else {
            this.sortParamsConfig[param].sortDescending = !this.sortParamsConfig[param].sortDescending;
        }
        for (let i = 0; i < this.sortParams.length; i++) {
            if (this.sortParams[i] !== param) {
                this.sortParamsConfig[this.sortParams[i]].firstToggle = true;
            }
        }
        this.sortParamsConfig[param].sortDescending ? this.order = 'des' : this.order = 'asc';
        this.getPatinetPaymentDetails();
    }

    /**
    * Function to set items Per page value
    * @param  {any} limitValue
    * @param  {any} event
    */
    setLimit(limitValue: any, event: any) {
        if (limitValue !== null) {
            this.master = limitValue;
            this.setPagination.changedValue = true;
            this.setPagination.itemsPerPage = this.master;
            this.paginationItems = this.setPagination.emitterEvent();
            this.reqItemsPerPage = this.paginationItems.passedItems;
            this.reqPageOffset = this.paginationItems.reqOffset;
            this.getPatinetPaymentDetails();
        }
    }

    /**
     * Function to set maximum items to be displayed in a page
     * @param  {any} selectedPageNumber
     */
    maxItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber < this.paymentTotaslCount) {
            this.selectedType = selectedPageNumber + 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /**
     * Function to capture event emitted from pagination component
     * @param  {any} event
     */
    paginationComponentEvent(event: any) {
        this.reqItemsPerPage = event.itemsPerPage;
        this.reqPageOffset = event.offset;
        if (event.isClicked) {
            this.getPatinetPaymentDetails();
        }
    }

    /**
     * Function to set minimum no of items to be displayed in apage
     * @param  {any} selectedPageNumber
     */
    minItemsPerPage(selectedPageNumber: any) {
        if (selectedPageNumber > 1) {
            this.selectedType = selectedPageNumber - 1;
            this.setLimit(this.selectedType, event)
        }
    }

    /* Search Function fro listing */
    searchEvent = () => {
        this.reqPageOffset = 0;
        this.getPatinetPaymentDetails();
    }

    /*Location Fetching function*/
    getLocation = () => {
        this.apiSubscriptions.push(this._patientPaymentService.getLocation()
            .subscribe((res: any) => {
                this.locationList = res.data;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loading = false;
                }));
    }

    getPatinetPaymentDetails = () => {
        this.loading = true;
        this.recentPaymentsApiSubscription?.unsubscribe();
        this.recentPaymentsApiSubscription = this._patientPaymentService.getPatinetPaymentDetails(this.searchValue, this.reqItemsPerPage, this.reqPageOffset, this.selectedLocation,
            this.selectedPaymentType, this.sortParam, this.order)
            .subscribe((res: any) => {
                if (!res.data) {
                    this.patientPaymentDetails = [];
                } else {
                    this.patientPaymentDetails = res.data;
                    this.patientPaymentDetails.forEach( (payment: any) => {
                        payment.currencySymbol = config.currency[payment.currency];
                    });
                }

                this.paymentTotaslCount = res.count;
                if (this.reqPageOffset >= 0) {
                    if (this.patientPaymentDetails.length !== 0) {
                        this.startCount = this.reqPageOffset + 1;
                        this.endCount = this.startCount + this.patientPaymentDetails.length - 1;
                    } else {
                        this.startCount = 0;
                        this.endCount = 0;
                    }
                }
                this.loading = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loading = false;
                });
    }

    showPaymentPopupUpdated(id: any) {
        this.loading = true;
        this._restrictOutsideScrollService.hideBackgroundScroll();
        this.dialogRefPaymentPopup = this.dialog.open(PaymentDetailsPopupComponent, {            
            disableClose: true,
            panelClass: 'payment-details-popup-wrap',
            data: {
                id: id,
            }
        });

        this.dialogRefPaymentPopup.componentInstance.newItemEvent.subscribe((result: any) => {
            if (result !== 'no_updates') {
                this.getPatinetPaymentDetails();
            }
            this.loading = false;
            this._restrictOutsideScrollService.showBackgroundScroll();
        });

        this.dialogRefPaymentPopup.componentInstance.loaded.subscribe( (response: any) => {
            this.loading = false;
        });
    }


    ngOnInit() {
        this.selectedType = 10;
        this.getLocation();
        this.getPatinetPaymentDetails();
        for (let i = 0; i < this.sortParams.length; i++) {
            let newConfig = {
                sortDescending: true,
                firstToggle: true
            }
            this.sortParamsConfig[this.sortParams[i]] = newConfig;
        }
        this.limitSubscription = this.limitInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.setLimit(this.selectedType, event);
                return EMPTY;
            })
        ).subscribe();
        this.searchSubscription  = this.searchInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(event => {
                this.searchEvent();
                return EMPTY;
            })
        ).subscribe();
    }

    ngAfterContentChecked() {
        this.isTouchDevice = ("ontouchstart" in document.documentElement);
	}

    ngOnDestroy() {
        this.inputSubscription?.unsubscribe();
        this.oneTimeApiSubscription?.unsubscribe();
        this.apiSubscriptions.forEach((subscription: any) => {
            subscription?.unsubscribe();
        });
        this.limitSubscription?.unsubscribe();
        this.searchSubscription?.unsubscribe();
        this.recentPaymentsApiSubscription?.unsubscribe();

        this.dialogRefPaymentPopup?.close();
        this.oneTimePaymentDialog?.close();
        this.oneTimeConfirmationDialog?.close();
    }
}
